import { render } from "./EvaluationApprovalView.vue?vue&type=template&id=5adb653e"
import script from "./EvaluationApprovalView.vue?vue&type=script&lang=js"
export * from "./EvaluationApprovalView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__